import React from "react";

import "./error-message.styles.scss";

const mapError = (code) => {
  switch (code) {
    case "auth/user-not-found":
    case "auth/wrong-password":
      return "Benutzername oder Passwort falsch";

    default:
      return "";
  }
};

const ErrorMessage = ({ error }) => {
  return error ? (
    <div className="error-message">
      <h3>{mapError(error.code)}</h3>
    </div>
  ) : (
    <div />
  );
};

export default ErrorMessage;
